{
  "hero": {
    "title": "Services",
    "cta": "Get in touch"
  },
  "services": [
    {
      "number": "01",
      "title": "Strategic UI/UX & Frontend Consultancy",
      "description": "For complex platforms and tech-driven companies. With 20 years of experience, I provide high-level technical leadership for large-scale projects.",
      "items": [
        {
          "title": "Interface Audits",
          "description": "Identifying friction points in complex user journeys."
        },
        {
          "title": "Design Systems",
          "description": "Building scalable Figma-to-Code libraries (React/Vue)."
        },
        {
          "title": "Architecture & Performance",
          "description": "Ensuring your frontend is as fast as it is beautiful."
        }
      ]
    },
    {
      "number": "02",
      "title": "Holistic Brand Engineering",
      "description": "From the first sketch to the final deploy. I don't believe in \"disconnected\" branding. I build your visual identity and your digital storefront as a single, living organism.",
      "items": [
        {
          "title": "Identity Design",
          "description": "Logos, typography, and brand books that translate to the web."
        },
        {
          "title": "High-Performance Web Dev",
          "description": "Custom-coded websites built for conversion and speed."
        },
        {
          "title": "Digital Ecosystems",
          "description": "Ensuring your brand feels the same on a smartphone as it does on a desktop."
        }
      ]
    },
    {
      "number": "03",
      "title": "Cinematic Content Production",
      "description": "The missing link in modern business. I produce the high-end video and photography that most agencies expect you to provide yourself. I design your website around the content I shoot.",
      "items": [
        {
          "title": "Brand Stories",
          "description": "Cinematic videos that humanize your company."
        },
        {
          "title": "Product Demo & Explainer Videos",
          "description": "Making complex tech easy to understand."
        },
        {
          "title": "Asset Libraries",
          "description": "A monthly bank of professional photos and short-form video (Reels/TikTok) to keep your social media active."
        }
      ]
    }
  ]
}
